import { render, staticRenderFns } from "./ServicePricesList.vue?vue&type=template&id=fb0b46c0&scoped=true"
import script from "./ServicePricesList.vue?vue&type=script&lang=js"
export * from "./ServicePricesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0b46c0",
  null
  
)

export default component.exports